import { render, staticRenderFns } from "./OthInEdit.vue?vue&type=template&id=56809beb"
import script from "./OthInEdit.vue?vue&type=script&lang=js"
export * from "./OthInEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports